// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"f2e29149","447":"4a82f694","967":"8773ebc8"}[chunkId] + ".chunk.js";
};